// DEPENDENCIES
import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";
import SignatureCanvas from 'react-signature-canvas';
import { Link, useLocation } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
// COMPONENTS
import jwtDecode from 'jwt-decode';
// ICONS
// CUSTOM COMPONENTS
import Section from '../../components/Section';
import * as alert from '../../../redux/alertSnackBarRedux';
import ContentBlock from '../../components/ContentBlock';
import CustomBlock from '../../components/CustomBlock';
import ContentHeader from '../../components/ContentHeader';
import * as confirmModal from '../../../redux/confirmModalRedux';
import InputBlock from '../../components/InputBlock';
import SelectBlock from '../../components/SelectBlock';
import Button from '../../components/Button';
// SERVICES
import * as proposalService from './../../../services/service/proposalService';

const initialState = {
    ProposalId: '',
    UserId: '',
    Signature: ''
}

const validationModel = {
    SignatureVal: ''
}

const ClientProposalApprovalPage = (props) => {
    const iframeRef = useRef();
    const { showAlert } = props;
    const history = useHistory();
    const useQueryString = () => new URLSearchParams(useLocation().search);
    const [token, setToken] = useState(useQueryString().get('token'));
    const [proposalId, setProposalId] = useState('');
    const [modal, setModal] = useState(false);
    const [sigRef, setSigRef] = useState('');
    const [userId, setUserId] = useState('');
    const [validation, setValidation] = useState({ ...validationModel });
    const [clientProposalApproveModel, setClientProposalApproveModel] = useState({ ...initialState });

    useEffect(() => {
        if (token) {
            jwtDecoder();
        }
    }, []);

    const jwtDecoder = () => {
        var decoded = jwtDecode(token);
        if (new Date(decoded.exp * 1000) > new Date()) {
            const { ProposalId, UserId } = decoded;
            GetProposalIFramePreview(ProposalId, token, UserId);
        }
        else {
            showAlert({ message: 'The link has expired', variant: 'error' });
            history.replace('/error')
        }
    }

    const checkValidations = () => {
        let success = true;
        if (!clientProposalApproveModel.ProposalId || !clientProposalApproveModel.UserId
            || !clientProposalApproveModel.Signature) {
            success = false;
        }
        if (!clientProposalApproveModel.Signature) {
            setValidation({ ...validation, SignatureVal: 'Signature is required' });
        }
        return success;
    }

    const validateBase64String = (base64String) => {
        var base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
        return base64regex.test(base64String.split('base64,')[1]);
    }

    const ClientApproveProposal = () => {
        proposalService.ClientProposalApproval(clientProposalApproveModel).then(res => {
            showAlert({ message: res.message, variant: 'success' });
            history.replace('/approval-success');
        }).catch((ex) => {
            showAlert({ message: ex.message, variant: 'error' });
        }).finally(() => {
            setModal(false);
        })
    }

    const GetProposalIFramePreview = (id, jwt_token, userId) => {
        proposalService.GetProposalPreview(id, jwt_token).then(res => {
            iframeRef.current.src = "data:application/pdf;base64," + res;
            if (res) {
                setProposalId(id);
                setUserId(userId);
            }
            else {
                history.replace('/error');
                showAlert({ message: 'You do not have enough permission to access the page', variant: 'error' });
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    return (
        <Section removeContainer containerStyle={{ display: 'inline-block', height: '100%', width: '100%', position: 'absolute', overflow: 'auto' }} rowStyle={{ position: 'absolute', overflow: 'auto', height: '100%', width: '100%' }}>
            <ContentBlock columnStyle={{ height: '100%', width: '100%' }}>
                <CustomBlock className="content-container--card-style--with-shadow" style={{ position: 'absolute', overflow: 'auto', height: '100%', width: '100%' }}>
                    <ContentHeader
                        title={`Approve Proposal`}
                        headerSize="sm"
                        primaryButtonText="Approve"
                        primaryButtonBackgroundColor="info--bg mr-0 mb-5"
                        primaryButtonOnClick={() => {
                            setModal(true);
                        }}
                    />
                    <iframe ref={iframeRef} style={{ height: '90%', width: '100%' }} title="description"></iframe>
                    <div>

                    </div>
                    <div className="form-group row">
                        <div className='w-100 d-flex justify-content-space-between align-items-center'>
                            <div className='w-50 d-flex justify-content-start'>
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    Signature
                                </label>
                                <div className="col-lg-9 col-xl-6">
                                    <SignatureCanvas
                                        penColor='black'
                                        backgroundColor='aliceblue'
                                        canvasProps={{ style: { width: '100%', height: '100%' } }}
                                        ref={ref => {
                                            setSigRef(ref);
                                        }}
                                        onEnd={() => {
                                            var dataUrl = { ...sigRef }.toDataURL();
                                            if (validateBase64String(dataUrl)) {
                                                setClientProposalApproveModel({ ...clientProposalApproveModel, ProposalId: proposalId, Signature: dataUrl.toString(), UserId: userId })
                                                setValidation({ ...validation, SignatureVal: '' })
                                            }
                                        }}
                                    />
                                    {
                                        validation.SignatureVal &&
                                        <div className="invalid-feedback display-block">
                                            This is a required field
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className='w-50 h-50 d-flex justify-content-end'>
                                <div className="d-flex justify-content-end">
                                    <Button
                                        text="Clear"
                                        onClick={() => {
                                            sigRef.clear();
                                            setClientProposalApproveModel({ ...clientProposalApproveModel, ProposalId: proposalId, Signature: '', UserId: userId })
                                        }
                                        }
                                        className="info--bg md"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </CustomBlock>
                <Modal centered size="sm" show={modal} onHide={() => {
                    setModal(false)
                }}>
                    <Modal.Header closeButton>
                        <Modal.Title>Are you sure you want to approve this proposal?</Modal.Title>
                    </Modal.Header>
                    {
                        validation.SignatureVal &&
                        <Modal.Body>
                            <div className="invalid-feedback display-block">
                                Please fill all the required fields*
                            </div>
                        </Modal.Body>
                    }
                    <Modal.Footer>
                        <button
                            className="btn btn-secondary mr-2"
                            onClick={() => {
                                setModal(false)
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="btn btn-success mr-2"
                            onClick={() => {
                                if (checkValidations()) {
                                    ClientApproveProposal();
                                }
                            }}
                        >
                            Approve
                        </button>
                    </Modal.Footer>
                </Modal>
            </ContentBlock>
        </Section>
    )
}

const mapStateToProps = (state) => ({
    auth: state.auth
})

export default connect(mapStateToProps, {
    ...alert.actions,
    ...confirmModal.actions
})(ClientProposalApprovalPage);